import React from 'react';
import { Chip } from '@mui/material';
import { PreviewOutlined } from '@mui/icons-material';

import { getConfidenceLevel, NOT_ELIGIBLE } from '../../utils/getConfidenceLevel';

/**
 * A component that displays a Material-UI Chip with styling
 * based on a confidence score and eligibility status.
 *
 * If `matchable` is false, it displays "Not Eligible".
 * Otherwise, it displays a confidence level (e.g., "Low", "High")
 * based on the `confidenceScore`.
 */
export const ConfidenceScoreChip = ({
  confidenceScore,
  matchable,
}: {
  confidenceScore: number;
  matchable: boolean;
}): JSX.Element => {
  const chipProps = matchable ? getConfidenceLevel(confidenceScore) : NOT_ELIGIBLE;

  return (
    <Chip
      label={chipProps.label}
      icon={<PreviewOutlined />}
      color={chipProps.color}
      style={chipProps.style}
    />
  );
};
